import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  List,
  ListItem,
  PrimaryButton,
  Text,
} from "@certn/cascadia-react";
import { Trans } from "react-i18next";

export function NonBiometricIdInfoWeCollectModal() {
  return (
    <Dialog
      width={600}
      aria-label="non-biometric-info-we-collect-modal-dialogue"
    >
      {({ close }) => (
        <>
          <DialogHeader
            onClose={close}
            testID="non-biometric-info-we-collect-modal-header"
          >
            <Text style="global/modal-header" color="text-weak">
              <Trans>Information we collect</Trans>
            </Text>
          </DialogHeader>
          <DialogContent>
            <Text style="global/body-primary" color="text-base">
              <Trans>
                Certn has partnered with Interac® verification service to
                securely verify your identity directly with your bank.
                Information we collect and share in the report include:
                <br />
                <br />
                <List type="unordered">
                  <ListItem>
                    <Trans>Name</Trans>
                  </ListItem>
                  <ListItem>
                    <Trans>Date of birth</Trans>
                  </ListItem>
                  <ListItem>
                    <Trans>Address</Trans>
                  </ListItem>
                  <ListItem>
                    <Trans>Financial institution</Trans>
                  </ListItem>
                </List>
                <br />
                No financial or transactional information will be collected.
              </Trans>
            </Text>
          </DialogContent>
          <DialogFooter>
            <PrimaryButton onPress={close} size="medium">
              <Trans>Close</Trans>
            </PrimaryButton>
          </DialogFooter>
        </>
      )}
    </Dialog>
  );
}
